"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardCustomizationsProvider = exports.useDashboardCustomizationsContext = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
/**
 * @internal
 */
var DashboardCustomizationsContext = react_1.createContext({});
DashboardCustomizationsContext.displayName = "DashboardCustomizationsContext";
/**
 * @internal
 */
exports.useDashboardCustomizationsContext = function (localCustomizationOverrides) {
    var globalCustomizations = react_1.useContext(DashboardCustomizationsContext);
    return tslib_1.__assign(tslib_1.__assign({}, globalCustomizations), localCustomizationOverrides);
};
/**
 * @internal
 */
function DashboardCustomizationsProvider(props) {
    var children = props.children, components = tslib_1.__rest(props, ["children"]);
    return (react_1.default.createElement(DashboardCustomizationsContext.Provider, { value: components }, children));
}
exports.DashboardCustomizationsProvider = DashboardCustomizationsProvider;
//# sourceMappingURL=DashboardCustomizationsContext.js.map